import React from 'react'
import { Link } from "react-router-dom";
import { LanguageDropdown } from './header-language-dropdown';
import { NavItem } from './header-nav-item';
import { AuthButton } from './header-auth-button';
import { ProfileProvider } from './profile-hook';
import { useSelector } from 'react-redux';

const organizationLabel = {
  en: 'Organizations',
  id: 'Organisasi'
}
const programLabel = {
  en: 'Programs',
  id: 'Program'
}
const eventLabel = {
  en: 'Events',
  id: 'Acara'
}
const resourceLabel = {
  en: 'Resources',
  id: 'Produk'
}

const HeaderNav = () => {
  const language = useSelector(state => state.system.language)

  return (
    <nav className="flex items-center relative">
      <NavItem>
        <Link to="/organization">
          {organizationLabel[language.name]}
        </Link>
      </NavItem>
      <NavItem>
        <Link to="/program">
          {programLabel[language.name]}
        </Link>
      </NavItem>
      <NavItem>
        <Link to="/event">
          {eventLabel[language.name]}
        </Link>
      </NavItem>
      <NavItem>
        <Link to="/resource">
          {resourceLabel[language.name]}
        </Link>
      </NavItem>
      <ProfileProvider>
        <AuthButton />
      </ProfileProvider>
      <LanguageDropdown />
    </nav>
  )
}

export { HeaderNav }
